export default __webpack_public_path__ + "static/studioface-bnw-4aae583d5f640a43ac25c5eb355a726f.mp4";